'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { motion } from 'motion/react';
import { IN_VIEW } from './constants';
interface FadeInOnScrollProps {
  children: React.ReactNode;
  y?: number;
  duration?: number;
  delay?: number;
  className?: string;
}
const FadeInOnScroll: React.FC<FadeInOnScrollProps> = t0 => {
  const $ = _c(11);
  const {
    children,
    y: t1,
    duration: t2,
    delay: t3,
    className
  } = t0;
  const y = t1 === undefined ? 16 : t1;
  const duration = t2 === undefined ? 0.5 : t2;
  const delay = t3 === undefined ? 0 : t3;
  let t4;
  if ($[0] !== y) {
    t4 = {
      opacity: 0,
      y
    };
    $[0] = y;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 1,
      y: 0
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== delay || $[4] !== duration) {
    t6 = {
      duration,
      delay
    };
    $[3] = delay;
    $[4] = duration;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== className || $[8] !== t4 || $[9] !== t6) {
    t7 = <motion.div className={className} initial={t4} whileInView={t5} viewport={IN_VIEW} transition={t6}>{children}</motion.div>;
    $[6] = children;
    $[7] = className;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default FadeInOnScroll;